import getFormsObj from './getFormsObj';

export default async function getFormsLocal(all = false) {
  const formsArray = [];
  const formsObj = await getFormsObj(all);
  if (!formsObj || formsObj === undefined || formsObj === null || typeof formsObj !== 'object') return formsArray;
  Object.entries(formsObj).forEach(([formId]) => {
    const form = formsObj[formId];
    form.formId = formId;
    formsArray.push(form);
  });
  return formsArray;
}
